import fetchHelper from 'helpers/FetchHelper'
import { BASE_API_LIVE_SWAP } from 'config/constants/endpoints'
import { ReportType, TreeNode, WalletReportTypes } from './types'

export const getTreeNode = (id: string): Promise<TreeNode[]> => {
  return new Promise((resolve, reject) => {
    try {
      fetchHelper.fetch(`${BASE_API_LIVE_SWAP}/ref/tree/${id}`).then(([res, status]: any) => {
        if (res?.statusCode === 200) {
          resolve(res?.data)
        }

        reject(res)
      })
    } catch (err) {
      reject(err)
    }
  })
}

export const getTreeNode2 = (id: string): Promise<TreeNode[]> => {
  return new Promise((resolve, reject) => {
    try {
      fetchHelper.fetch(`${BASE_API_LIVE_SWAP}/ref/tree-deep/${id}/5`).then(([res, status]: any) => {
        if (res?.statusCode === 200) {
          resolve(res?.data)
        }

        reject(res)
      })
    } catch (err) {
      reject(err)
    }
  })
}

export const getRefReport = (id: string): Promise<ReportType> => {
  return new Promise((resolve, reject) => {
    try {
      fetchHelper.fetch(`${BASE_API_LIVE_SWAP}/ref/tree/report/${id}`).then(([res, status]: any) => {
        if (res?.statusCode === 200) {
          resolve(res?.data)
        }

        reject(res)
      })
    } catch (err) {
      reject(err)
    }
  })
}

export const getWalletReports = (): Promise<WalletReportTypes> => {
  return new Promise((resolve, reject) => {
    try {
      fetchHelper.fetch(`${BASE_API_LIVE_SWAP}/report/wallets`).then(([res, status]: any) => {
        if (res?.statusCode === 200) {
          resolve(res?.data)
        }

        reject(res)
      })
    } catch (err) {
      reject(err)
    }
  })
}

export const getReportSetting = (key: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    try {
      fetchHelper.fetch(`${BASE_API_LIVE_SWAP}/report/setting/${key}`).then(([res, status]: any) => {
        if (res?.statusCode === 200) {
          resolve(res?.data)
        }

        reject(res)
      })
    } catch (err) {
      reject(err)
    }
  })
}

export const updateReportSetting = (payload: any, cbs?: any, cbe?: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    try {
      fetchHelper
        .fetch(`${BASE_API_LIVE_SWAP}/report/setting`, {
          method: 'POST',
          body: JSON.stringify(payload),
        })
        .then(([res, status]: any) => {
          if (res?.statusCode === 200 || res?.statusCode === 201) {
            if (cbs) cbs(res)
          } else if (cbe) cbe(res)
        })
    } catch (err) {
      reject(err)
    }
  })
}
